export const caseStatusEnum = [
  { id: "Open", name: "Open" },
  { id: "Overdued", name: "Overdued" },
  { id: "Completed", name: "Completed" },
  { id: "Closed", name: "Closed" }, // archived
];

export const defaultfilterCaseStatus = "Open";